/**
 * Detect whether the creator has any design content (uploaded image, text, etc.)
 * on the live canvas or in saved position state.
 */

import { hasDesignObjects } from '@/services/canvas';
import { useCanvasStateManager } from '@/stores/canvasStateManager';
import { useDesignStore } from '@/stores/designStore';

export function hasCreatorDesign(): boolean {
  const manager = useCanvasStateManager.getState();

  if (manager.getPositionsWithDesigns().length > 0) {
    return true;
  }

  if (manager.canvas && hasDesignObjects(manager.canvas)) {
    return true;
  }

  const designCanvas = useDesignStore.getState().canvas;
  if (designCanvas && hasDesignObjects(designCanvas)) {
    return true;
  }

  return false;
}
